import {
  Component, OnInit, Output, EventEmitter, Input, ViewEncapsulation
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-card-list-footer',
  templateUrl: './card-list-footer.component.html',
  styleUrls: ['./card-list-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CardListFooterComponent implements OnInit {
  @Input() type: string;
  @Input() enabledIcons: boolean;
  @Input() checkboxIcon: any[];
  @Output() isSubmit = new EventEmitter<boolean>();
  @Output() totalSelection = new EventEmitter<boolean>();
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  sendData() {
    this.isSubmit.emit(true);
  }

  changeTotalSelection(valueCheck) {
    this.totalSelection.emit(valueCheck);
  }
}
